import React from "react";
import "./ContentHelpDeclaration.scss";
import {AppSettings} from "../../../../AppSettings";

function ContentHelpDeclaration() {

    return (
        <div className="helpPage">
            <div className="helpHeader">
                <div>
                    <h1 className="helpTitle">Aide à la déclaration</h1>
                    <p className="helpSubtitle">Guides visuels pour remplir vos déclarations URSSAF et TVA.</p>
                </div>
            </div>

            <div className="helpGrid">
                <div className="helpCard">
                    <div className="helpCardLabel">URSSAF</div>
                    <div className="helpCardTitle">Déclaration de revenus</div>
                    <img
                        className="helpCardImg"
                        src={`${AppSettings.API_ENDPOINT}/images/image/aide_urssaf.png`}
                        alt="Aide déclaration URSSAF"
                    />
                </div>

                <div className="helpCard">
                    <div className="helpCardLabel">TVA</div>
                    <div className="helpCardTitle">Déclaration de TVA</div>
                    <img
                        className="helpCardImg"
                        src={`${AppSettings.API_ENDPOINT}/images/image/aide_tva.png`}
                        alt="Aide déclaration TVA"
                    />
                </div>
            </div>
        </div>
    );
}

export default ContentHelpDeclaration;
